import { render, staticRenderFns } from "./ChapterScript.vue?vue&type=template&id=51f02072&"
import script from "./ChapterScript.vue?vue&type=script&lang=js&"
export * from "./ChapterScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports